export * from './PdfModal';
import { PdfModal as ModalComponent, Header, Title, ToolContainer } from './PdfModal';
import { Pdf, Controller, Container } from '../Pdf/Pdf';

export const PdfModal = Object.assign(ModalComponent, {
  Header,
  Title,
  ToolContainer,
  PdfContainer: Container,
  Pdf,
  Controller,
});
